// src/components/HoldingsHistory.jsx
import React from 'react';
import { HistoryGrid } from '@1823-partners/core';
import { fetchHolding } from '../api';
import { formatDate } from '../utils';

const FIELD_NAMES = {
  CUSIP: 'CUSIP',
  SECURITY: 'Security',
  ISSUER_TRUST: 'Issuer Trust',
  WAL: 'WAL',
  BOOK_YIELD: 'Book Yield',
  CREDIT_ENHANCEMENT: 'Credit Enhancement',
  THICKNESS: 'Thickness',
  NOTES: 'Notes',
  STATUS: 'Status',
  ASOFDT: 'ASOFDT',
};

const COLUMNS = [
  {
    headerName: 'CUSIP',
    field: 'CUSIP',
    pinned: 'left',
  },
  {
    headerName: 'Security',
    field: 'SECURITY',
  },
  {
    headerName: 'Issuer Trust',
    field: 'ISSUER_TRUST',
  },
  {
    headerName: 'WAL',
    field: 'WAL',
    type: 'numericColumn',
    valueFormatter: (params) => {
      if (params.value == null) return '';
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }).format(params.value);
    },
  },
  {
    headerName: 'Book Yield',
    field: 'BOOK_YIELD',
    type: 'numericColumn',
    valueFormatter: (params) => {
      if (params.value == null) return '';
      return new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      }).format(params.value / 100);
    },
  },
  {
    headerName: 'Credit Enhancement',
    field: 'CREDIT_ENHANCEMENT',
    type: 'numericColumn',
    valueFormatter: (params) => {
      if (params.value == null) return '';
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(params.value);
    },
  },
  {
    headerName: 'Thickness',
    field: 'THICKNESS',
    type: 'numericColumn',
    valueFormatter: (params) => {
      if (params.value == null) return '';
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(params.value);
    },
  },
  {
    headerName: 'Notes',
    field: 'NOTES',
  },
  {
    headerName: 'Status',
    field: 'STATUS',
  },
  {
    headerName: 'ASOFDT',
    field: 'ASOFDT',
    // ASOFDT is a date-only field already normalized to 'YYYY-MM-DD' by the
    // transformData prop below (via UTC-safe core formatDate). Render the
    // string as-is; do NOT re-parse with new Date(...).toLocaleString(), which
    // re-interprets it in local time and shifts the day west of UTC.
  },
];

const HoldingsHistory = ({ cusip, asofdt }) => (
  <HistoryGrid
    fetchHistory={() => fetchHolding(cusip, asofdt)}
    fetchParams={[cusip, asofdt]}
    fieldNames={FIELD_NAMES}
    columns={COLUMNS}
    transformData={(data) =>
      data.map((row) => ({ ...row, ASOFDT: formatDate(row.ASOFDT) }))
    }
  />
);

export default HoldingsHistory;
